import { render, staticRenderFns } from "./GoodsTabContent.vue?vue&type=template&id=1959e2e6&scoped=true&"
import script from "./GoodsTabContent.vue?vue&type=script&lang=js&"
export * from "./GoodsTabContent.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTabContent.vue?vue&type=style&index=0&id=1959e2e6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959e2e6",
  null
  
)

export default component.exports